import React, { useState } from 'react';

export default function AppSpinner() {
  return (
    <div>
      App Spinner !
    </div>
  );
}
